import { useQuery } from '@tanstack/react-query';

import { useEffect } from 'react';
import { fetchTeam } from '@/api/v4/team.api';
import { QueryKey } from '@/config/query-client';
import { isIdNotRecognizedError } from '@/helpers/is-id-not-recognized-error';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

import { teamIdState } from '../team.state';
import { useAtomValue } from 'jotai';

export const useTeam = () => {
  const { hasAtLeastOnePermission } = useUserPermissions();
  const teamId = useAtomValue(teamIdState);
  const navigateTo = useNavigateTo();

  const getTeam = () => {
    if (!teamId) return;
    return fetchTeam(teamId);
  };

  const query = useQuery({
    queryKey: [QueryKey.Team, teamId],
    queryFn: getTeam,
    retry: false,
    enabled:
      !!teamId && hasAtLeastOnePermission([PERMISSION.VIEW_TEAM_HOME_PAGE]),
  });

  useEffect(() => {
    if (query.error && isIdNotRecognizedError(query.error)) {
      navigateTo.notFound();
    }
  }, [query.error, navigateTo]);

  return query;
};
